import React, { useState, useEffect } from "react";
import { EventService } from "../../../services";

import ReactPaginate from "react-paginate";
import { Link, useParams } from "react-router-dom";

import { injectModels } from "../../../redux/injectModels";
import { SalesAudienceService } from "../../../services";
import { toast } from "react-toastify";
import { Button, Table, Modal, Form } from "react-bootstrap";
import { handleConsoleError } from "../../../utils/common-methods";

const PostSale = (props) => {
  const [audienceNumber, setAudienceNumber] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const { eventId } = useParams();
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    fileTitle: "",
    file: null,
  });

  const rowsPerPage = 10;
  const offset = currentPage * rowsPerPage;
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getData(eventId);
    getAudianceData(eventId);
  }, []);

  const getData = async (eventId) => {
    props.application.setLoading(true);
    try {
      if(eventId)
      {
      const res = await SalesAudienceService.getEventSalesById(eventId);
      if (res?.isSuccess) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    }
    } catch (error) {
      props.application.setLoading(false);
       const message=handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const getAudianceData = async (eventId) => {
    props.application.setLoading(true);
    try {
      const res = await EventService.getEventById(eventId);
      if (res?.isSuccess) {
        setAudienceNumber(res?.data?.totalAudience);
        props.application.setLoading(false);
      } else {
       // toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      props.application.setLoading(true);
      const response = await SalesAudienceService.DeleteEventSales(id);
      if (response?.isSuccess) {
        toast.success("Record deleted successfully");
        getData(eventId);
      } else {
        toast.error(response?.message || "Failed to delete the record");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(
        error?.message || message
      );
    } finally {
      props.application.setLoading(false);
    }
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  //********** Handle File Upload (Only CSV & Excel) *******************************
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (file && allowedTypes.includes(file.type)) {
      setFormData({ ...formData, file });
    } else {
      toast.error("Only CSV and Excel files are allowed");
      e.target.value = null;
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.file) {
      toast.error("Please upload a valid file");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("EventId", eventId);
    formDataToSend.append("FileTitle", formData?.fileTitle);
    formDataToSend.append("File", formData?.file);

    try {
      props.application.setLoading(true);
      const response = await SalesAudienceService.addEventSales(formDataToSend);
      if (response?.isSuccess) {
        toast.success("Data added successfully");
        getData(eventId);
        setShowModal(false);
      } else {
        toast.error(response?.message || "Failed to add data");
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
    } finally {
      props.application.setLoading(false);
    }
  };

  const handleFileDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAudienceSubmit = async () => {
    try {
      if (!audienceNumber) {
        toast.error("Audience number is required");
        return;
      }
      props.application.setLoading(true);

      const payload = {
        EventId: eventId,
        totalAudience: audienceNumber,
      };

      const response = await SalesAudienceService.addEventAudeience(payload);

      if (response?.isSuccess) {
        //console.log("Final Email sent");
         toast.success(response?.message);
      }

      await getData();
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setAudienceNumber(value);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton5 d-flex ">
            <div className="verifier-new1">
              <label>Audience Number:</label>
            </div>
            <div className="verifier-new3">
              <input
                type="number"
                className="form-control"
                placeholder="Enter number"
                value={audienceNumber}
                onChange={handleInputChange}
              />
            </div>
            <div className="verifier-new2">
              <Button className="me-2" onClick={handleAudienceSubmit}>
                Update Audience Numbers
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton">
            <Button
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              Add Past Sales Data
            </Button>{" "}
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                  <th>File</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.fileTitle}</td>
                          <td>
                            <Button
                              variant="link"
                              onClick={() => handleFileDownload(item?.file)}
                            >
                              <i className="fa-solid fa-download"></i>
                            </Button>
                          </td>

                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDelete(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData?.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>

      <div className="salesmodel25">
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <div className="salesmodelbody">
            <Modal.Header closeButton>
              <Modal.Title>Event Sale</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="fileTitle">
                  <Form.Label>File Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="fileTitle"
                    value={formData?.fileTitle}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="file">
                  <Form.Label>Upload File (CSV or Excel)</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileChange}
                    required
                  />
                </Form.Group>
                <div className="salesButton">
                  <Button type="submit" className="mt-3">
                    Save
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(PostSale);
